module.exports = __webpack_public_path__ + "static/media/ok_icon.4fe7ba92.png";